import { render, staticRenderFns } from "./CrewBehavior.vue?vue&type=template&id=34801bd4&scoped=true&"
import script from "./CrewBehavior.vue?vue&type=script&lang=js&"
export * from "./CrewBehavior.vue?vue&type=script&lang=js&"
import style0 from "./CrewBehavior.vue?vue&type=style&index=0&id=34801bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34801bd4",
  null
  
)

export default component.exports